import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  Filler,
  ChartOptions,
  ScriptableContext,
  ChartType
} from 'chart.js';

/**
 * Register all Chart.js components immediately to ensure they're available
 * This fixes issues with chart elements not being registered when components render
 */
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler // Important: This enables the fill option in charts
);

/**
 * Common chart options to maintain consistent styling
 * @param chartType - Type of chart these options apply to
 */
export const getCommonChartOptions = (chartType: ChartType): ChartOptions<ChartType> => {
  return {
    responsive: true,
    maintainAspectRatio: true,
    animation: false, // Disable animations for PDF export
    plugins: {
      legend: {
        position: 'top' as const,
        labels: {
          font: {
            family: "'Inter', Arial, sans-serif",
            size: 12,
          },
          color: '#4b5563',
        },
      },
      title: {
        display: false,
      },
      tooltip: {
        enabled: true,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        titleFont: {
          family: "'Inter', Arial, sans-serif",
          size: 14,
        },
        bodyFont: {
          family: "'Inter', Arial, sans-serif",
          size: 13,
        },
        padding: 10,
      },
    },
  };
};

/**
 * Common color schemes for different chart elements
 */
export const chartColors = {
  blue: {
    primary: 'rgba(59, 130, 246, 0.7)',
    border: 'rgba(59, 130, 246, 1)',
    background: 'rgba(59, 130, 246, 0.2)'
  },
  green: {
    primary: 'rgba(16, 185, 129, 0.7)',
    border: 'rgba(16, 185, 129, 1)',
    background: 'rgba(16, 185, 129, 0.2)'
  },
  red: {
    primary: 'rgba(239, 68, 68, 0.7)',
    border: 'rgba(239, 68, 68, 1)',
    background: 'rgba(239, 68, 68, 0.2)'
  },
  purple: {
    primary: 'rgba(139, 92, 246, 0.7)',
    border: 'rgba(139, 92, 246, 1)',
    background: 'rgba(139, 92, 246, 0.2)'
  },
  orange: {
    primary: 'rgba(249, 115, 22, 0.7)',
    border: 'rgba(249, 115, 22, 1)',
    background: 'rgba(249, 115, 22, 0.2)'
  },
  // More color schemes as needed
};
